/* eslint-disable max-lines-per-function */
import React, { useEffect, useState, useCallback } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { insereInscricao } from '../../services/inscricao';
import { showMessageError, showMessageSuccess } from '../others/toastr';
import { ToggleButton } from 'primereact/togglebutton';
import { tabelaPrecoPromocao } from '../../modulos/function/promocaoCidade';
import { Message } from 'primereact/message';
import { UpdateAssoc } from '../../services/associados';
import { montaObjetoParaUpdateAssociado } from '../../modulos/function/montaObjetoAssociado';
import * as moment from 'moment';

const dataFinalDaPromocaoDeFinados2023 = moment('2024-03-01').utc();
const dataDeFinados = moment('2023-10-31').utc();
const dataAtual = moment().utc();
const estamosNoPeriodoDeFinados = dataAtual.isBetween(dataDeFinados, dataFinalDaPromocaoDeFinados2023);

const formasDePagamentosPermitidas = {
    7: 'Recorrente',
    8: 'Escelsa'
};

const ValorAdesao = props => {
    const [isDialog, setDialog] = useState(false);
    const [isProgress, setProgress] = useState(true);
    const [isAdesao, setAdesao] = useState();
    const [planoCidade, setPlanoCidade] = useState({});
    const { subGrupo, valueBase, Associado } = props;
    const [valorComDesconto, setValorComDesconto] = useState(false);
    const arrayValidacoesFinados2023 = [estamosNoPeriodoDeFinados, formasDePagamentosPermitidas[Associado.AssTipoCobranca] !== undefined];
    const condicoesPromocaoFinados2023 = arrayValidacoesFinados2023.every(condicoes => condicoes === true);
    const [checkTemDesconto, setCheckTemDesconto] = useState(false);
    const [ativarBotao, setAtivarBotao] = useState(true);
    const [hideInput, setHideInput] = useState(true);
    const [travaAtribuirDesconto, setTravaAtribuirDesconto] = useState(false);
    const [valorPlanoAdesaoSemDesconto, setValorPlanoAdesaoSemDesconto] = useState(false);

    async function setValorAdesao() {
        try {
            if (!isAdesao) {
                return showMessageError('Erro', 'O valor de adesão não pode ser zero!');
            }

            const dadosAdesao = {
                Pagamento: null,
                tipoPagamento: null,
                Valor: isAdesao,
                Inscricao: props.inscricao,
                valorPago: null
            };

            setProgress(false);

            const response = await insereInscricao(dadosAdesao);

            if (response.status === 422) {
                throw new Error(response.statusText || 'Verifique o valor inserido!');
            }

            setDialog(false);

            showMessageSuccess('Sucesso', 'Valor da Adesao inserido com sucesso');

            if (Associado.idDescontoEspecial !== null) {
                Associado.idDescontoEspecial = null;

                const payloadUpdateAssociado = montaObjetoParaUpdateAssociado(Associado);

                payloadUpdateAssociado.Cidade = Associado.CodCidade;
                payloadUpdateAssociado.Grupo = payloadUpdateAssociado.Grupo.trim();
                payloadUpdateAssociado.Carencia = String(payloadUpdateAssociado.Carencia);

                const atualizarAssociadoResponse = await UpdateAssoc(props.inscricao, payloadUpdateAssociado);

                if (atualizarAssociadoResponse.status !== 200) {
                    return showMessageError('Ooops..', 'Problemas ao remover o desconto especial. Tente novamente.');
                }
            }

            if (condicoesPromocaoFinados2023 && !valorComDesconto && checkTemDesconto !== undefined && Associado.idDescontoEspecial === null) {
                Associado.idDescontoEspecial = 5;

                const payloadUpdateAssociado = montaObjetoParaUpdateAssociado(Associado);

                payloadUpdateAssociado.Cidade = Associado.CodCidade;
                payloadUpdateAssociado.Grupo = payloadUpdateAssociado.Grupo.trim();
                payloadUpdateAssociado.Carencia = String(payloadUpdateAssociado.Carencia);

                const atualizarAssociadoResponse = await UpdateAssoc(props.inscricao, payloadUpdateAssociado);

                if (atualizarAssociadoResponse.status !== 200) {
                    return showMessageError('Ooops..', 'Problemas ao lançar o desconto especial, por favor tente novamente.');
                }

                showMessageSuccess('Sucesso', 'Desconto especial inserido com sucesso');
            }

            setTimeout(() => {
                document.location.reload();
            }, 1500);
        } catch (error) {
            showMessageError('Tente novamente', 'Verifique o valor inserido!');
        } finally {
            setProgress(true);
        }
    }

    useEffect(() => {
        (async () => {
            try {
                const { 'Produto.descricao': descricaoPlano, Cidade } = Associado;
                let valorPlanoAdesao;

                const { cidadeIbge } = props;

                const plano = (await tabelaPrecoPromocao(true, 'cidade', cidadeIbge, 'Adesao', subGrupo.trim(), 1, 10000))[0];

                if (Associado.troca) {
                    valorPlanoAdesao = plano?.adesao_troca;
                } else {
                    valorPlanoAdesao = Associado.TipoVenda === 'REAB ' ? plano?.adesao_reab : plano?.adesao_novo;
                }

                if (!plano || !valorPlanoAdesao) {
                    return showMessageError(`Não foi encontrado o valor do ${descricaoPlano ? descricaoPlano : 'plano'} para a cidade ${Cidade}`, 'É necessário cadastrar o valor do plano!');
                }

                setPlanoCidade(plano);
                setAdesao(valorPlanoAdesao);
                setValorPlanoAdesaoSemDesconto(valorPlanoAdesao);
            } catch (error) {
                showMessageError('Algo deu errado', 'tente novamente mais tarde!');
            }
        })();
    }, []);

    function handleValorAdesaoInput({ value }) {
        if (value) {
            setAdesao(value);
        }
    }

    useEffect(() => {
        if (subGrupo.trim().substr(0, 3) === 'ZPC') {
            setAtivarBotao(true);
            setAdesao(valueBase ? parseFloat(valueBase) : 0);
            setHideInput(true);
        } else if (subGrupo.trim().substr(0, 3) === 'ZTA') {
            setAtivarBotao(true);
            setAdesao(Associado['ProdutosPreco.valorBase'] ? parseFloat(Associado['ProdutosPreco.valorBase']) : 0);
            setHideInput(false);
        } else if (props.title === 'Editar Valor Adesão') {
            setAtivarBotao(false);
        } else {
            setAtivarBotao(true);
            setHideInput(true);
            setTravaAtribuirDesconto(false);
        }
    }, [subGrupo, valueBase, Associado]);

    const possuiDescontoEmVigencia = desconto => {
        if (!desconto) { return null; }

        const vigenciaInicio = desconto?.vigenciaInicio;
        const vigenciaFim = desconto?.vigenciaFim;
        const valorComDescontos = desconto?.valorComDescontos;

        return !vigenciaInicio || !vigenciaFim || !valorComDescontos ||
            !moment().utc().isBetween(moment(vigenciaInicio).utc(), moment(vigenciaFim).utc()) ?
            null : valorComDescontos;
    };

    let possuiDescontoCadastrado;

    switch (Associado.AssTipoCobranca) {
        case 1:
            possuiDescontoCadastrado = possuiDescontoEmVigencia(planoCidade?.descontoBoleto);

            break;
        case 7:
            possuiDescontoCadastrado = possuiDescontoEmVigencia(planoCidade?.descontoCartao);

            break;
        case 8:
            possuiDescontoCadastrado = possuiDescontoEmVigencia(planoCidade?.descontoEscelsa);

            break;
        default:
            break;
    }

    useEffect(() => {
        if (valorComDesconto && possuiDescontoCadastrado) {
            setAdesao(Number(possuiDescontoCadastrado));
        }
    }, [valorComDesconto, possuiDescontoCadastrado]);

    const footer = (
        <div>
            <Button
                loading={isProgress}
                disabled={ativarBotao ? false : !isAdesao}
                label="Confirmar"
                icon="pi pi-check"
                className="p-button-success"
                onClick={() => setValorAdesao()}
            />
        </div>
    );

    const AvisoPromocaoFinados = useCallback(() => {
        setCheckTemDesconto(possuiDescontoCadastrado);

        if (condicoesPromocaoFinados2023 && checkTemDesconto !== undefined) {
            return <Message
                severity="warn"
                text="Caso você opte por aplicar o desconto, o cliente perderá a bonificação da décima segunda parcela."
            />;
        }

        return <></>;
    }, [checkTemDesconto]);

    const atribuirValorRetirarDesconto = value => {
        setValorComDesconto(value);
        setAdesao(valorPlanoAdesaoSemDesconto);
    };

    return (
        <>
            {ativarBotao && <Button
                data-testid="btn-adesao"
                label={props.title}
                onClick={() => setDialog(true)}
                className={props.color}
            />}
            <Dialog
                header="Grupo Zelo"
                footer={footer}
                visible={isDialog}
                onHide={() => setDialog(false)}
                style={{ width: '50vw' }}
                modal={true}
                data-testid="dialog"
            >
                {isProgress ? (
                    <>
                        <div className='valorAdesao'>
                            <AvisoPromocaoFinados />
                            <p style={{
                                marginBottom: '10px',
                                marginTop: '10px'
                            }}>{hideInput ? 'Verifique o valor da adesão:' : 'Digite o valor da adesão:'}</p>

                            <div className='valorAdesaoCampos' >
                                <div className='valorAdesaoInput'>
                                    <InputNumber
                                        value={isAdesao}
                                        disabled={hideInput}
                                        onChange={handleValorAdesaoInput}
                                        mode="currency"
                                        currency="BRL"
                                        locale="pt-BR"
                                        placeholder="R$ 0,00"
                                    />
                                </div>
                                {possuiDescontoCadastrado !== 0 && possuiDescontoCadastrado && !travaAtribuirDesconto &&
                                    <div className='valorAdesaoAplicarDesconto'>
                                        <ToggleButton
                                            onLabel="Retirar desconto"
                                            offLabel="Aplicar desconto"
                                            onIcon="pi pi-check"
                                            offIcon="pi pi-times"
                                            checked={valorComDesconto}
                                            onChange={e => atribuirValorRetirarDesconto(e.value)} />
                                    </div>
                                }
                            </div>
                        </div>
                    </>
                ) : (
                    <div className="LoadingWrapper">
                        <ProgressSpinner />
                    </div>
                )}
            </Dialog>
        </>
    );
};

export default ValorAdesao;
